module.exports = __webpack_public_path__ + "img/5.2d43d2bf.png";